import * as h3 from "h3-js";
import mapboxgl from "mapbox-gl";
import { polygonToCells } from "h3-js";
import * as turf from "@turf/turf";
import * as ss from "simple-statistics";
import geojson2h3 from "geojson2h3";
import {
  serverURL,
  drawClicked,
  totalJobsDistricts,
  totalPopulationDistricts,
  districtFeatures,
} from "../../src/store";
import { districts_data } from "../../src/data/district_data.js";
let currentRes;

function mergeToMultiPolygon(tileFeatures) {
  if (!tileFeatures.length) return null;

  // 1. Wrap the pieces in a FeatureCollection
  const fc = {
    type: "FeatureCollection",
    features: tileFeatures.map((f) => ({
      type: "Feature",
      geometry: f.geometry, // Mapbox feature geometry is already valid GeoJSON
      properties: {},
    })),
  };

  // 2. turf.combine dissolves identical-type geometries into one MultiPolygon
  //    (If all inputs are Polygons or MultiPolygons, the first feature of
  //     the output will be a MultiPolygon.)
  const combined = turf.combine(fc);

  // combined.features[0] is the unified shape
  return combined.features[0];
}

export function h3_MapBoxZoom(map, name, radioCheck, server) {
  if (!map) {
    return;
  }
  document.getElementById("loading").style.opacity = 1;
  if (map.getSource("clusterSource")) {
    map.removeLayer("clusterLayer");
    map.removeSource("clusterSource");
  }
  if (map.getSource("isochroneSource")) {
    map.removeLayer("isochroneLayer");
    map.removeSource("isochroneSource");
  }

  if (map.getLayer("box-layer")) {
    map.removeLayer("box-layer");
    map.removeSource("box");
  }
  let hexData;

  fetch(`${server}api/data/hexinfo?name=${encodeURIComponent(name)}`)
    .then((response) => response.json())
    .then((responseData) => {
      hexData = responseData;

      normalizeValues(hexData, "pop");

      normalizeValues(hexData, "ptal");
      normalizeValues(hexData, "ptal", "reverse");
      normalizeValues(hexData, "age_15_45");
      normalizeValues(hexData, "bikewalktowork");
      normalizeValues(hexData, "jobs");
      normalizeValues(hexData, "lessthan10km");

      hexData.forEach((feat) => {
        feat.demandNorm =
          feat.popNorm +
          feat.ptalNorm * 2 +
          feat.jobsNorm * 2 +
          (feat.age_15_45Norm +
            feat.bikewalktoworkNorm +
            feat.lessthan10kmNorm) /
            3;
      });
      hexData.forEach((feat) => {
        if ((feat.popNorm == 0) & (feat.ptalNorm == 0)) {
          feat.needNorm = 0;
        } else {
          feat.needNorm =
            feat.popNorm +
            feat.ptal_rev_Norm * 2 +
            feat.jobsNorm * 2 +
            feat.lessthan10kmNorm;
        }
      });
    })
    .then(() => {
      var centroids = districts_data;

      const results = centroids.filter((centroid) => centroid.name === name);

      map.flyTo({
        center: [results[0].lon, results[0].lat],
        essential: true,
        zoom: 8,
      });
      map.setFilter("counties", null);
      map.setPaintProperty("counties", "line-color", "transparent");
      let features;
      map.once("moveend", function () {
        setTimeout(() => {
          features = map.queryRenderedFeatures({
            layers: ["counties"],
            filter: ["==", "NAME", name],
          });
          districtFeatures.set(mergeToMultiPolygon(features));
          map.setFilter("counties", ["==", "NAME", name]);
          map.setPaintProperty("counties", "line-color", "black");
          // Calculate the total area of the features
          let totalArea = 0;
          features.forEach((feature) => {
            const area = turf.area(feature);
            totalArea += area;
          });
          if (totalArea < 50000000) {
            map.flyTo({
              center: [results[0].lon, results[0].lat],
              zoom: 11.5,
              essential: true,
            });
          }
          if (totalArea >= 50000000 && totalArea < 100000000) {
            map.flyTo({
              center: [results[0].lon, results[0].lat],
              zoom: 10.5,
              essential: true, // This animation is considered essential with respect to prefers-reduced-motion
            });
          }
          if (totalArea >= 100000000 && totalArea < 1000000000) {
            map.flyTo({
              center: [results[0].lon, results[0].lat],
              zoom: 9.5,
              essential: true, // This animation is considered essential with respect to prefers-reduced-motion
            });
          }
          if (totalArea >= 1000000000 && totalArea < 10000000000) {
            map.flyTo({
              center: [results[0].lon, results[0].lat],
              zoom: 8.5,
              essential: true, // This animation is considered essential with respect to prefers-reduced-motion
            });
          }

          if (totalArea > 3500000000) {
            map.flyTo({
              center: [results[0].lon, results[0].lat],
              zoom: 8.01,
              essential: true, // This animation is considered essential with respect to prefers-reduced-motion
            });
          }

          let currentZoomRangeLevel = null;

          map.on("zoomend", () => {
            var zoomLevel = map.getZoom();

            var zoomLevelRounded = Math.floor(zoomLevel * 100);

            const ranges = [
              { min: 0, max: 799, level: 7 },
              { min: 799, max: 899, level: 8 },
              { min: 899, max: 100000000, level: 10 },
            ];

            let newZoomRangeLevel = null;

            ranges.forEach((range) => {
              if (
                zoomLevelRounded > range.min &&
                zoomLevelRounded < range.max
              ) {
                newZoomRangeLevel = range.level;
              }
            });

            // Check if the zoom range level has changed
            if (newZoomRangeLevel !== currentZoomRangeLevel) {
              currentZoomRangeLevel = newZoomRangeLevel;

              addH3Layer(
                map,
                currentZoomRangeLevel,
                features,
                totalArea,
                hexData,
                radioCheck
              );
            }
          });
        }, 0);
      });
      document.getElementsByClassName("legend")[0].style.opacity = 1;
    });

  fetch(`${server}api/data/district?district=${encodeURIComponent(name)}`).then(
    (response) =>
      response.json().then((responseData) => {
        totalJobsDistricts.set(responseData[0]["totalJobs"]);
        totalPopulationDistricts.set(responseData[0]["totalPopulation"]);
      })
  );
}

export function h3_MapBoxZoom_DrawnPolygon(
  map,
  poly,
  radioCheck,
  server,
  Draw
) {
  if (!map) {
    return;
  }
  document.getElementById("loading").style.opacity = 1;
  if (map.getSource("clusterSource")) {
    map.removeLayer("clusterLayer");
    map.removeSource("clusterSource");
  }
  if (map.getSource("isochroneSource")) {
    map.removeLayer("isochroneLayer");
    map.removeSource("isochroneSource");
  }

  if (map.getLayer("box-layer")) {
    map.removeLayer("box-layer");
    map.removeSource("box");
  }

  const coordinates = poly.geometry.coordinates;
  const latLngCoords = coordinates.map((ring) =>
    ring.map((coord) => [coord[1], coord[0]])
  );
  let newIndex = polygonToCells(latLngCoords, 10);
  console.log(newIndex);
  let h3Indexes = [...new Set(newIndex.map((h) => h3.cellToParent(h, 7)))];

  console.log("H3 grid IDs in polygon:", h3Indexes, h3Indexes.length);

  if (h3Indexes.length > 150) {
    alert("Draw Smaller Polygon");
    return;
  } else {
    let hexData;

    fetch(`${server}api/data/res7?res7=${h3Indexes}`).then((response) =>
      response.json().then((responseData) => {
        console.log(responseData);
        totalJobsDistricts.set(responseData[0]["totalJobs"]);
        totalPopulationDistricts.set(responseData[0]["totalPopulation"]);
      })
    );
    fetch(`${server}api/data/drawnPoly?res7=${h3Indexes}`)
      .then((response) => response.json())
      .then((responseData) => {
        hexData = responseData;

        normalizeValues(hexData, "pop");

        normalizeValues(hexData, "ptal");
        normalizeValues(hexData, "ptal", "reverse");
        normalizeValues(hexData, "age_15_45");
        normalizeValues(hexData, "bikewalktowork");
        normalizeValues(hexData, "jobs");
        normalizeValues(hexData, "lessthan10km");

        hexData.forEach((feat) => {
          feat.demandNorm =
            feat.popNorm +
            feat.ptalNorm * 2 +
            feat.jobsNorm * 2 +
            (feat.age_15_45Norm +
              feat.bikewalktoworkNorm +
              feat.lessthan10kmNorm) /
              3;
        });
        hexData.forEach((feat) => {
          if ((feat.popNorm == 0) & (feat.ptalNorm == 0)) {
            feat.needNorm = 0;
          } else {
            feat.needNorm =
              feat.popNorm +
              feat.ptal_rev_Norm * 2 +
              feat.jobsNorm * 2 +
              feat.lessthan10kmNorm;
          }
        });
      })
      .then(() => {
        let [lon, lat] = turf.centroid(poly).geometry.coordinates;

        map.flyTo({
          center: [lon, lat],
          essential: true,
          zoom: 8,
        });
        map.setFilter("counties", null);
        map.setPaintProperty("counties", "line-color", "transparent");
        let features;
        map.once("moveend", function () {
          setTimeout(() => {
            features = [poly];
            // console.log(features);

            map.setPaintProperty("counties", "line-color", "black");
            // Calculate the total area of the features
            let totalArea = 0;
            features.forEach((feature) => {
              const area = turf.area(feature);
              totalArea += area;
            });
            if (totalArea < 50000000) {
              map.flyTo({
                center: [lon, lat - 0.011],
                zoom: 11.5,
                essential: true,
              });
            }
            if (totalArea >= 50000000 && totalArea < 100000000) {
              map.flyTo({
                center: [lon, lat],
                zoom: 10.5,
                essential: true, // This animation is considered essential with respect to prefers-reduced-motion
              });
            }
            if (totalArea >= 100000000 && totalArea < 1000000000) {
              map.flyTo({
                center: [lon, lat - 0.03],
                zoom: 9.5,
                essential: true, // This animation is considered essential with respect to prefers-reduced-motion
              });
            }
            if (totalArea >= 1000000000 && totalArea < 10000000000) {
              map.flyTo({
                center: [lon, lat - 0.05],
                zoom: 8.5,
                essential: true, // This animation is considered essential with respect to prefers-reduced-motion
              });
            }

            if (totalArea > 3500000000) {
              map.flyTo({
                center: [lon, lat - 0.07],
                zoom: 8.01,
                essential: true, // This animation is considered essential with respect to prefers-reduced-motion
              });
            }

            let currentZoomRangeLevel = null;

            map.on("zoomend", () => {
              var zoomLevel = map.getZoom();

              var zoomLevelRounded = Math.floor(zoomLevel * 100);

              const ranges = [
                { min: 0, max: 799, level: 7 },
                { min: 799, max: 899, level: 8 },
                { min: 899, max: 100000000, level: 10 },
              ];

              let newZoomRangeLevel = null;

              ranges.forEach((range) => {
                if (
                  zoomLevelRounded > range.min &&
                  zoomLevelRounded < range.max
                ) {
                  newZoomRangeLevel = range.level;
                }
              });

              // Check if the zoom range level has changed
              if (newZoomRangeLevel !== currentZoomRangeLevel) {
                currentZoomRangeLevel = newZoomRangeLevel;

                addH3Layer(
                  map,
                  currentZoomRangeLevel,
                  features,
                  totalArea,
                  hexData,
                  radioCheck
                );
              }
            });
          }, 0);
        });
        document.getElementsByClassName("legend")[0].style.opacity = 1;
        Draw.deleteAll();
      });
  }
}

function addH3Layer(map, res, features, totalArea, hexData, radioCheck) {
  if (map.getLayer("box-layer")) {
    map.removeLayer("box-layer");
    map.removeSource("box");
  }
  const allHexagons = [];
  const bounds = map.getBounds();

  // Convert the bounds to a GeoJSON Polygon
  const polygon = turf.polygon([
    [
      [bounds.getWest(), bounds.getSouth()],
      [bounds.getEast(), bounds.getSouth()],
      [bounds.getEast(), bounds.getNorth()],
      [bounds.getWest(), bounds.getNorth()],
      [bounds.getWest(), bounds.getSouth()],
    ],
  ]);

  // Calculate the area of the polygon in square meters
  const area = turf.area(polygon);

  const addHexagons = (geometry) => {
    const hexagons = geojson2h3.featureToH3Set(geometry, res);
    allHexagons.push(...hexagons);
  };

  if (area < totalArea) {
    addHexagons(polygon);
  } else {
    for (const feature of features) {
      if (feature.geometry.type === "Polygon") {
        addHexagons(feature);
      } else if (feature.geometry.type === "MultiPolygon") {
        for (const polygonCoords of feature.geometry.coordinates) {
          addHexagons({
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: polygonCoords,
            },
            properties: {},
          });
        }
      }
    }
  }

  const getProperties = (hexagon, resKey) => {
    const filteredHexData = hexData.filter((item) => item[resKey] === hexagon);
    const res8 = filteredHexData[0]["h3_polyfill_res8"];
    const ptalValue = calculateAverage(filteredHexData, "ptal");
    const ptal_rev_NormValue = calculateAverage(
      filteredHexData,
      "ptal_rev_Norm"
    );
    const jobsValue = calculateAverage(filteredHexData, "jobs");
    const ageValue = calculateAverage(filteredHexData, "age_15_45");
    const ageValueNorm = calculateAverage(filteredHexData, "age_15_45Norm");
    const BikeWalkValue = calculateAverage(filteredHexData, "bikewalktowork");
    const BikeWalkValueNorm = calculateAverage(
      filteredHexData,
      "bikewalktoworkNorm"
    );
    const LT10Value = calculateAverage(filteredHexData, "lessthan10km");
    const LT10ValueNorm = calculateAverage(filteredHexData, "lessthan10kmNorm");

    const jobsNormValue = calculateAverage(filteredHexData, "jobsNorm");

    const demandNormValue = calculateAverage(filteredHexData, "demandNorm");
    const needNormValue = calculateAverage(filteredHexData, "needNorm");
    const ptalNormValue = calculateAverage(filteredHexData, "ptalNorm");
    const popNormValue = calculateAverage(filteredHexData, "popNorm");

    const popValue =
      filteredHexData.length > 0
        ? filteredHexData.reduce((sum, item) => sum + parseFloat(item.pop), 0)
        : 0;

    return {
      id: hexagon,
      resKey8: res8,
      ptal: ptalValue,
      pop: popValue,
      jobs: jobsValue,
      bikewalktowork: BikeWalkValue,
      bikewalktoworkNorm: BikeWalkValueNorm,
      age_15_45: ageValue,
      lessthan10km: LT10Value,
      lessthan10kmNorm: LT10ValueNorm,
      age_15_45Norm: ageValueNorm,
      demandNorm: demandNormValue,
      needNorm: needNormValue,
      ptalNorm: ptalNormValue,
      ptal_rev_Norm: ptal_rev_NormValue,
      popNorm: popNormValue,
      jobsNorm: jobsNormValue,
      readinesslevel: Math.round(
        (BikeWalkValueNorm + ageValueNorm + LT10ValueNorm) / 3
      ),
    };
  };

  const resKeyMap = {
    10: "h3_polyfill",
    8: "h3_polyfill_res8",
    7: "h3_polyfill_res7",
  };
  const resKey = resKeyMap[res];

  if (resKey) {
    const h3_ids = hexData.map((feat) => feat[resKey]);
    const uniqueHexagons = [...new Set(allHexagons)].filter((hex) =>
      h3_ids.includes(hex)
    );
    const feature = geojson2h3.h3SetToFeatureCollection(uniqueHexagons, (hex) =>
      getProperties(hex, resKey)
    );
    if (feature.features.length > 0) {
      const values = feature.features.map((obj) => obj.properties[radioCheck]);

      let sortedValues = values.sort((a, b) => a - b);
      sortedValues = downsampleIfNeeded(sortedValues);

      var jenks = ss.jenks(sortedValues, 4);

      map.addSource("box", {
        type: "geojson",
        data: feature,
      });

      map.addLayer(
        {
          id: "box-layer",
          type: "fill",
          source: "box",
          paint: {
            "fill-opacity": 0.8,
            "fill-color": [
              "interpolate",
              ["linear"],
              ["get", radioCheck],
              0,
              "#af0505",
              jenks[1],
              "orange",
              jenks[2],
              "yellow",
              jenks[3],
              "lightgreen",
              jenks[4],
              "green",
            ],
          },
        },
        "tunnel-path-trail"
      );
    } else {
      return;
    }
    map.on("idle", () => {
      if (map.getLayer("box-layer")) {
        document.getElementsByClassName("leftMenu")[0].style.height = "435px";
        document.getElementsByClassName("leftMenuExtras")[0].style.opacity = 1;
        document.getElementById("loading").style.opacity = 0;
      }
    });
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });
    map.on("click", "box-layer", (e) => {
      var dc;
      drawClicked.subscribe((value) => {
        dc = value;
      });
      map.getCanvas().style.cursor = "pointer";
      if (dc == false) {
        if (
          e.features.length > 0
          /*(map.getPaintProperty("ptal-layer-line", "line-opacity") == 1)*/
        ) {
          // Change the cursor style as a UI indicator.
          map.getCanvas().style.cursor = "pointer";

          let description;
          const coordinates = e.features[0].geometry.coordinates[0][0];
          const popdes = e.features[0].properties.popNorm;
          const jobs = e.features[0].properties.jobsNorm * 2;
          const age_15_45 = e.features[0].properties.age_15_45Norm;
          const bikewalktowork = e.features[0].properties.bikewalktoworkNorm;
          const lessthan10km = e.features[0].properties.lessthan10kmNorm;
          const h3 = e.features[0].properties.id;
          const demand = e.features[0].properties.demandNorm;
          const need = e.features[0].properties.needNorm;
          const rawptaldes = Math.round(e.features[0].properties.ptalNorm) * 2;
          const rawptaldes_rev =
            Math.round(e.features[0].properties.ptal_rev_Norm) * 2;

          description = `<b> H3_Polyfill: </b> <span style='color:black'> ${h3} </span> <br>
            <b> Ridership Potential Score: </b> <span style='color:black'> ${Math.round(
              demand
            )} </span> <br><b> Decarbonisation Potential: </b> <span style='color:black'> ${need} </span> <br><b>Population:</b> <span style='color:black'>${popdes} / 7 </span><br><b>High PTAL Score:</b> <span style='color:black'>${rawptaldes} / 14 </span>
            <br><b>Low PTAL Score:</b> <span style='color:black'>${rawptaldes_rev} / 14 </span>
             <br><b>Jobs:</b> <span style='color:black'>${Math.round(
               jobs
             )} / 14</span>
             <br><b>Potential micromobility adopters:</b> <span style='color:black'>${Math.round(
               (lessthan10km + age_15_45 + bikewalktowork) / 3
             )} / 7 </span>`;
          /*+`<br><b>Less than 10km Commute:</b> <span style='color:black'>${Math.round(
              lessthan10km
            )} / 7 </span>
         
          <br><b>Age 15 - 45:</b> <span style='color:black'>${Math.round(
            age_15_45
          )} / 7</span>
          <br><b>Bike/Walk to Work:</b> <span style='color:black'>${Math.round(
            bikewalktowork
          )} / 7</span>`*/

          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          popup.setLngLat(coordinates).setHTML(description).addTo(map);
        } else {
          return;
        }
      } else {
        return;
      }
    });
    map.on("mouseleave", "box-layer", () => {
      /*map.setPaintProperty("ptal-layer-line", "line-color", "transparent");*/
      map.getCanvas().style.cursor = "";
      popup.remove();
    });
  }
}
function normalizeValues(data, propertyName, reverse) {
  // Extract values from each object
  let values = data.map((obj) => obj[propertyName]);
  let sortedValues = values.sort((a, b) => a - b);

  sortedValues = downsampleIfNeeded(sortedValues);
  const quantileValues = ss.jenks(sortedValues, 7);

  if (reverse != "reverse") {
    data.forEach((obj) => {
      if (obj[propertyName] <= quantileValues[1]) {
        obj[`${propertyName}Norm`] = 0;
      } else if (obj[propertyName] < quantileValues[2]) {
        obj[`${propertyName}Norm`] = 1;
      } else if (obj[propertyName] < quantileValues[3]) {
        obj[`${propertyName}Norm`] = 2;
      } else if (obj[propertyName] < quantileValues[4]) {
        obj[`${propertyName}Norm`] = 3;
      } else if (obj[propertyName] < quantileValues[5]) {
        obj[`${propertyName}Norm`] = 4;
      } else if (obj[propertyName] < quantileValues[6]) {
        obj[`${propertyName}Norm`] = 5;
      } else if (obj[propertyName] < quantileValues[7]) {
        obj[`${propertyName}Norm`] = 6;
      } else {
        obj[`${propertyName}Norm`] = 7;
      }
    });
  } else {
    data.forEach((obj) => {
      if (obj[propertyName] <= quantileValues[1]) {
        obj[`${propertyName}_rev_Norm`] = 7;
      } else if (obj[propertyName] < quantileValues[2]) {
        obj[`${propertyName}_rev_Norm`] = 6;
      } else if (obj[propertyName] < quantileValues[3]) {
        obj[`${propertyName}_rev_Norm`] = 5;
      } else if (obj[propertyName] < quantileValues[4]) {
        obj[`${propertyName}_rev_Norm`] = 4;
      } else if (obj[propertyName] < quantileValues[5]) {
        obj[`${propertyName}_rev_Norm`] = 3;
      } else if (obj[propertyName] < quantileValues[6]) {
        obj[`${propertyName}_rev_Norm`] = 2;
      } else if (obj[propertyName] < quantileValues[7]) {
        obj[`${propertyName}_rev_Norm`] = 1;
      } else {
        obj[`${propertyName}_rev_Norm`] = 0;
      }
    });
  }
}
function calculateAverage(filteredHexData, property) {
  if (filteredHexData.length === 0) {
    return 0;
  }
  const sum = filteredHexData.reduce(
    (sum, item) => sum + parseFloat(item[property]),
    0
  );
  return sum / filteredHexData.length;
}
function systematicSample(data, interval) {
  return data.filter((_, index) => index % interval === 0);
}

function downsampleIfNeeded(data, threshold = 5000) {
  if (data.length > threshold) {
    let sampleSize = 1000;
    const interval = Math.floor(data.length / sampleSize);
    return systematicSample(data, interval);
  }
  return data;
}
